const translations = {
  "en": {
    "Days": "Days",
    "Hours": "Hours",
    "Min": "Min",
    "Sec": "Sec"
  },
  "zh-tw": {
    "Days": "天",
    "Hours": "小時",
    "Min": "分",
    "Sec": "秒"
  }
};

export default translations;
